export default __webpack_public_path__ + "static/media/image.prodigi-interactive.286e9eb1.png";